import { Link, useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { FiChevronRight } from "react-icons/fi";

const formatLabel = (segment) =>
  segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const AdminBreadcrumbs = () => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  const crumbs = segments.map((segment, index) => ({
    label: formatLabel(segment),
    to: "/" + segments.slice(0, index + 1).join("/"),
    isLast: index === segments.length - 1,
  }));

  return (
    <Breadcrumb listClassName="tw-mb-4 tw-flex tw-items-center tw-gap-1 tw-bg-transparent tw-p-0 tw-text-sm">
      {crumbs.map((crumb, index) => (
        <span key={crumb.to} className="tw-flex tw-items-center tw-gap-1">
          <BreadcrumbItem active={crumb.isLast} className={crumb.isLast ? "tw-font-medium tw-text-gray-900" : undefined}>
            {crumb.isLast ? (
              crumb.label
            ) : (
              <Link to={crumb.to} className="tw-text-gray-500 hover:tw-text-gray-700">
                {crumb.label}
              </Link>
            )}
          </BreadcrumbItem>
          {index < crumbs.length - 1 && (
            <span className="tw-text-gray-300">
              <FiChevronRight size={13} />
            </span>
          )}
        </span>
      ))}
    </Breadcrumb>
  );
};